'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/input-number/style/css');

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _css3 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css4 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _css5 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _css6 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 模版编辑表单
                                                                                                                                                                                                                                                                   * @param  {[type]}
                                                                                                                                                                                                                                                                   * @return {[type]}    [description]
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _file_uploader = require('./file_uploader');

var _file_uploader2 = _interopRequireDefault(_file_uploader);

var _product_desc_editor = require('./product_desc_editor');

var _product_desc_editor2 = _interopRequireDefault(_product_desc_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;
var RadioGroup = _radio2.default.Group;

var TemplateForm = _form2.default.create()(_react2.default.createClass({
    displayName: 'TemplateForm',
    getInitialState: function getInitialState() {
        return {};
    },
    handleSubmit: function handleSubmit(e) {
        var _this = this;

        e.preventDefault();
        this.props.form.validateFieldsAndScroll(function (err, values) {
            if (!err) {

                if (_this.props.template) {
                    values.id = _this.props.template.id;
                }
                _this.props.onSubmit(values);
            }
        });
    },
    render: function render() {
        var _props = this.props,
            form = _props.form,
            _props$template = _props.template,
            template = _props$template === undefined ? { sort: 0, status: 1, type: { id: 3, name: '照片书' } } : _props$template,
            types = _props.types,
            uploadSign = _props.uploadSign,
            token = _props.token;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        var tailFormItemLayout = {
            wrapperCol: {
                span: 14,
                offset: 6
            }
        };
        return _react2.default.createElement(
            _form2.default,
            { onSubmit: this.handleSubmit },
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u6A21\u7248\u7C7B\u578B' }),
                getFieldDecorator('type', {
                    rules: [{ required: true, message: '请选择模版类型!' }],
                    initialValue: '' + template.type.id
                })(_react2.default.createElement(
                    _select2.default,
                    { placeholder: '\u8BF7\u9009\u62E9\u6A21\u7248\u7C7B\u578B' },
                    types.map(function (type) {
                        return _react2.default.createElement(
                            Option,
                            { value: '' + type.id, key: type.id },
                            type.name
                        );
                    })
                ))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: '\u6A21\u7248\u6807\u9898',
                    hasFeedback: true
                }),
                getFieldDecorator('title', {
                    rules: [{
                        required: true,
                        message: '请输入模版标题'
                    }],
                    initialValue: template.title
                })(_react2.default.createElement(_input2.default, null))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: '\u6A21\u7248\u526F\u6807\u9898',
                    hasFeedback: true
                }),
                getFieldDecorator('subTitle', {
                    rules: [{
                        required: true,
                        message: '请输入模版副标题'
                    }],
                    initialValue: template.subTitle
                })(_react2.default.createElement(_input2.default, null))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: '\u6A21\u7248\u72B6\u6001'
                }),
                getFieldDecorator('status', {
                    rules: [{
                        required: true,
                        message: '请选择模版状态'
                    }],
                    initialValue: template.status
                })(_react2.default.createElement(
                    RadioGroup,
                    null,
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 1 },
                        '\u4E0A\u67B6'
                    ),
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 0 },
                        '\u4E0B\u67B6'
                    )
                ))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: '\u9ED8\u8BA4\u6392\u5E8F'
                }),
                getFieldDecorator('sort', {
                    rules: [{
                        required: true,
                        message: '请选择模版使用权限'
                    }],
                    initialValue: template.sort
                })(_react2.default.createElement(_inputNumber2.default, { min: 0 })),
                _react2.default.createElement(
                    'span',
                    { className: 'ant-form-text' },
                    ' \u79C1\u6709\u7C7B\u578B\u9760\u524D\uFF0C\u540C\u7C7B\u578B\u4EA7\u54C1\u5E8F\u53F7\u8D8A\u5C0F\u8D8A\u9760\u524D\uFF0C\u540C\u5E8F\u53F7\u540E\u6DFB\u52A0\u8005\u9760\u524D'
                )
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u9ED8\u8BA4\u56FE', required: true }),
                getFieldDecorator('defaultImage', {
                    rules: [{ required: true, message: '请添加默认图' }],
                    initialValue: template.defaultImage ? [template.defaultImage] : undefined
                })(_react2.default.createElement(_product_desc_editor2.default, { single: true, imageSize: '320x320' }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, {
                    label: '\u6A21\u7248\u6587\u4EF6',
                    extra: '\u8BF7\u4F7F\u7528indesign\u5236\u4F5C\u6A21\u677F\uFF0C\u5E76\u6253\u5305\u540E\u4E0A\u4F20'
                }),
                getFieldDecorator('url', {
                    valuePropName: 'url',
                    rules: [{
                        required: typeof template.id === 'undefined',
                        message: '请选择模版文件!'
                    }]
                })(_react2.default.createElement(_file_uploader2.default, { uploadSign: uploadSign, token: token, fuckurl: '' }))
            ),
            _react2.default.createElement(
                FormItem,
                tailFormItemLayout,
                _react2.default.createElement(
                    _button2.default,
                    { type: 'primary', htmlType: 'submit', size: 'large' },
                    '\u4FDD\u5B58'
                )
            )
        );
    }
}));

exports.default = TemplateForm;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/template_form.js
// module id = 1343
// module chunks = 0